import React,{ useState,useEffect } from 'react';
import ReactDOM from 'react-dom';
import '../appAlienware.css';

export default function RgbColorPicker() {

  return(
      <React.Fragment>
          {
             <div id="orion-keyboard-color-menu-wrapper">
             <div id="orion-keyboard-color-menu">
                <div id="picker">
                   <div className="farbtastic">
                      <div className="color" style={{backgroundColor: 'rgb(255, 9, 9)'}}></div>
                      <div className="wheel"></div>
                      <div className="overlay"></div>
                      <div className="h-marker marker" style={{left: '32px', top: '8px'}}></div>
                      <div className="sl-marker marker" style={{left: '38px', top: '64px'}}></div>
                   </div>
                </div>
             </div>
             <div className="" aria-label="Rainblow Play Pause button" tabIndex="1" id="onOffkeyBoBacklit" onClick={window.handleRGB}  onKeyDown={(e) => {
                  if (e.key !== 'Enter') { return } window.handleRGB()
               }}>
                <img id="onOffkeyBoBacklitAnim" src="./images/alienware/alienfx_play.svg" style={{ width: '100px', marginTop: '10px', marginLeft: '20px', display: 'block', cursor: 'pointer'}} />
             </div>
          </div>
         }
      </React.Fragment>
  )

}